/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import AppliedFilter from "../Components/AppliedFilter/AppliedFilter";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
} from "../Components/constant";
import useParamsQuery from "../Components/hooks/useParamsQuery";
import { formDataToObject, isEmptyObj } from "../Components/helper";
import AdvancedSearch from "./Components/NewAdvanceSearch";
import styles from "./ChequesSearch.styles";
import ReportTable from "../Components/ReportsTable/ReportTable";
import DateRangePicker from "./Components/DateRangePicker/DateRangePicker";
// import OrganizationSearch from "../Components/OrganizationSearch";
// import OrganizationStructure from "../../../components/Layout/OrganizationStructure/OrganizationStructure";
// import OrganizationStructure from "../../../components/Layout/OrganizationStructureNew/OrganizationStructure";
import OrganizationStructure from "./Components/OrganizationStructureNew/OrganizationStructure";
// import PersonalDetailsSearch from "../Components/PersonalDetailsSearch";
import Popover from "../Components/Popover/NewPopover";
import { getFilters, getFormattedQuery, getRoutePath } from "./utils";
import { ROUTES } from "../../../components/Routes";
import { SERVICES } from "../../../components/Layout/Services";
import Loader from "../../../components/Loader/Loader";
import SearchIconWithPeople from "../../../components/Svg/SearchIconWithPeople";
import EmptyFileIcon from "../../../components/Svg/EmptyFile";
import PageSyncCal from "../../../components/Layout/PageSyncCal";
import Heading from "../../../components/Layout/Heading";
import { OuterContainerStyles } from "../../../components/Layout/Typography";
import { get } from "../../../components/Layout/ApiHandler/apihandler";
import GenericTable from "../../../components/Layout/Table/GenericTable";
import Button from "../../../components/Layout/Button";
import { ToastAlertContext } from "../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import ExportButton from "./Components/ExportButton/ExportButton";
import OrganizationStructureForUser from "../../Member/Components/OrganizationStructureNew/OrganizationStructureForUser";
import ExportButtonForChapter from "./Components/ExportButton/ExportButtonForChapter";
// import ReloadIcon from "../../../components/Svg/ReloadIcon";

const LOADER_DELAY = 1000;
const PAGE = "page";

const FILTER_KEYS = {
  ADVANCE_FILTER: "advance-filter",
  // PERSONAL_FILTER: "personal-filter",
  ORGANISATION_STRUCTURE_FILTER: "orgainsation-structure-filter",
};

// const SEARCH_FILTERS = [
//   // {
//   //   key: FILTER_KEYS.PERSONAL_FILTER,
//   //   component: PersonalDetailsSearch,
//   //   popOverprops: {
//   //     heading: "Search by Personal Details",
//   //   },
//   // },
//    {
//     key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
//     component: <OrganizationStructure onUpdateValues={updateOrganizationStructureValues}/>,
//     popOverprops: { heading: "Organization Structure", minWidth: 413 },
//   },
//   {
//     key: FILTER_KEYS.ADVANCE_FILTER,
//     component: AdvancedSearch,
//     popOverprops: {
//       heading: "Advanced Search",
//     },
//   },
// ];
const tableHeaders = [
  // "Member Id",
  "S.No.",
  "Member Name",
  "Mode",
  "Cheque/DD No",
  "Cheque Date",
  "Bank Name",
  "Amount",
  "Payable City",
];
const initialFormValue = {
  dateOfBirthFrom: new Date(),
  dateOfBirthTo: new Date(),
  dateOfJoiningFrom: "",
  dateOfJoiningTo: "",
  appointedAtFrom: "",
  appointedAtTo: "",
  conferralDateFrom: "",
  conferralDateTo: "",
};

function ChequesReportsSearch() {
  const TITLE = "Cheques/DD Reports - BSG ContributionAdmin";
  const [searchData, setSearchData] = useState({});
  const [chequeData, setChequeData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const [clearContributions, setClearContributions] = useState(false);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const [profileData, setProfileData] = useState({});
  const [selectedSortMethod, setSelectedSortMethod] = useState("");
  const onModalToggle = () => setOpenModal((prev) => !prev);
  const [values, setValues] = useState({
    areaId: null,
    clusterId: null,
    zoneId: null,
    regionId: null,
    chapterId: null,
    districtId: null,
    blockId: null,
  });
  const [orgNames, setOrgNames] = useState({
    areaName: null,
    clusterName: null,
    zoneName: null,
    regionName: null,
    chapterName: null,
    districtName: null,
    blockName: null,
  });
  const [selectedPayableCity, setSelectedPayableCity] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedReport, setSelectedReportType] = useState("");
  const toast = useContext(ToastAlertContext);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const updatePayableCity = (value) => {
    setSelectedPayableCity(value);
  };
  const updatePaymentMethod = (value) => {
    setSelectedPaymentMethod(value);
  };
  const updateReportType = (value) => {
    setSelectedReportType(value);
  };
  const updateSortingMethod = (value) => {
    setSelectedSortMethod(value);
  };
  const updateOrganizationStructureValues = (updatedValues) => {
    // console.log(updatedValues);
    setValues(updatedValues);
  };

  // const SEARCH_FILTERS = [
  //   // {
  //   //   key: FILTER_KEYS.PERSONAL_FILTER,
  //   //   component: PersonalDetailsSearch,
  //   //   popOverprops: {
  //   //     heading: "Search by Personal Details",
  //   //   },
  //   // },
  //    {
  //     key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
  //     component: <OrganizationStructure onUpdateValues={updateOrganizationStructureValues}/>,
  //     popOverprops: { heading: "Organization Structure", minWidth: 413 },
  //   },
  //   {
  //     key: FILTER_KEYS.ADVANCE_FILTER,
  //     component: <AdvancedSearch/>,
  //     popOverprops: {
  //       heading: "Advanced Search",
  //     },
  //   },
  // ];

  // const clearFormRef = () => {
  //   Object.keys(AppliedFilterLabelMap).forEach((key) => {
  //     if (formRef.current[key]) {
  //       formRef.current[key].value = "";
  //       formRef.current[key]?.blur();
  //     }
  //   });
  // };

  // const resetFormState = () => {
  //   setSearchData([]);
  //   setAppliedFilters([]);
  //   clearFormRef();
  // };

  // const initializeFormState = (queryObject) => {
  //   if (!isEmptyObj(queryObject)) {
  //     clearFormRef();
  //     Object.keys(queryObject).forEach((key) => {
  //       if (formRef.current[key]) {
  //         formRef.current[key].value = queryObject[key];
  //       }
  //     });
  //   }
  // };

  // const updateSearchParam = (query) => {
  //   if (query?.length) {
  //     navigate(`${getRoutePath()}?${query}`);
  //   } else {
  //     navigate(`${getRoutePath()}`);
  //   }
  // };

  // const removeKeyFromQuery = (queryObject, filterKey) => {
  //   const updatedQuery = {
  //     ...queryObject,
  //     pageNumber: 0,
  //     pageSize: Constants.DEFAULT_PAGE_SIZE,
  //   };

  //   if (DATES.includes(filterKey)) {
  //     delete updatedQuery[filterKey];
  //     delete updatedQuery[`${filterKey.split("From")[0]}To`];
  //   } else {
  //     delete updatedQuery[filterKey];
  //   }

  //   if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
  //     delete updatedQuery[PAGE];
  //   }

  //   return updatedQuery;
  // };

  // const onRemoveFilter = (filterKey) => {
  //   // setPaginationInfo(intialPaginationState);
  //   let queryObject = getQueryObject();
  //   queryObject = removeKeyFromQuery(queryObject, filterKey);
  //   const updatedQuery = queryString.stringify(queryObject);
  //   updateSearchParam(updatedQuery);
  // };

  const fetchSearchData = async (
    queryParams,
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE,
  ) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery({
        ...queryParams,
        pageNumber,
        pageSize,
      });
      const url = `${SERVICES.GET_LIST_CHEQUES_DD_REPORTS}?${formattedQuery}`;
      const response = await get(url);
      if (response.ok) {
        const data = response.json();
        setSearchData(data.data.content);
      }
      // const { data } = await SERVICES.GET_MEMBER_DETAILS(formattedQuery);

      // Showing some delay to avoid loader flicker issue
      setTimeout(() => {
        // setSearchData(data.content);
        // setCurrentPage(data.number);
        // setTotalPages(data.totalPages);
        // setTotalElements(data.totalElements);
        setPageSize(pageSize);
        setIsLoading(false);
      }, LOADER_DELAY);
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DD");
  }
  // const formattedStartDate = formatDateToYYYYMMDD(
  //   initialAdvanceFormValue.dateOfBirthFrom
  // );
  // const formattedEndDate = formatDateToYYYYMMDD(
  //   initialAdvanceFormValue.dateOfBirthTo
  // );
  const constructQueryParameters = (
    // includeDates = true,
    // firstDate,
    // lastDate,
    formattedStartDate,
    formattedEndDate,
    selectedPayableCity,
    selectedPaymentMethod,
    selectedSortMethod,
  ) => {
    const queryParams = [];
    const optionalParams = {
      areaId: values.areaId,
      clusterId: values.clusterId,
      zoneId: values.zoneId,
      regionId: values.regionId,
      chapterId: values.chapterId,
      districtId: values.districtId,
      blockId: values.blockId,
    };

    for (const key in optionalParams) {
      if (optionalParams[key] !== null && optionalParams[key] !== undefined) {
        queryParams.push(`${key}=${optionalParams[key]}`);
      }
    }
    if (
      moment(formattedStartDate, "YYYY-MM-DD", true).isValid() &&
      moment(formattedEndDate, "YYYY-MM-DD", true).isValid()
    ) {
      queryParams.push(`from=${formattedStartDate}`);
      queryParams.push(`to=${formattedEndDate}`);
    }
    if (selectedPayableCity) {
      queryParams.push(`payableCity=${selectedPayableCity}`);
    }
    if (selectedPaymentMethod) {
      queryParams.push(`orderPaymentMethod=${selectedPaymentMethod}`);
    }
    if (selectedSortMethod) {
      queryParams.push(`sort=${selectedSortMethod}`);
    }
    // if (includeDates) {
    //   queryParams.push(`from=${formattedDateFrom}`);
    //   queryParams.push(`to=${formattedDateTo}`);
    // }

    // if (firstDate && lastDate) {
    //   queryParams.push(`from=${firstDate}`);
    //   queryParams.push(`to=${lastDate}`);
    // }

    return queryParams.join("&");
  };
  const removeFilter = () => {
    setClearContributions(true);
    setSearchParams("");
    setSelectedPayableCity("");
    setSelectedPaymentMethod("");
    setTimeout(() => {
      setClearContributions(false);
      setSearchPerformed(false);
      // setShowFilter(false);
    }, 100);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSearchPerformed(true);
    if (
      !initialAdvanceFormValue.dateOfBirthFrom ||
      !initialAdvanceFormValue.dateOfBirthTo
    ) {
      toast.show("Please select date", AlertStatus.ERROR);
      return;
    }

    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthFrom,
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthTo,
    );
    // const formattedQuery = constructQueryParameters(
    //   initialAdvanceFormValue.dateOfBirthFrom,
    //   initialAdvanceFormValue.dateOfBirthTo
    // );
    try {
      setIsLoading(true);
      // const formattedQuery = getFormattedQuery({
      //   ...queryParams,
      //   pageNumber,
      //   pageSize,
      // });
      const url = `${
        SERVICES.GET_LIST_CHEQUES_DD_REPORTS
      }?${constructQueryParameters(
        formattedStartDate,
        formattedEndDate,
        selectedPayableCity,
        selectedPaymentMethod,
        selectedSortMethod,
      )}`;
      const response = await get(url);
      // console.log(response);
      if (response.ok) {
        const data = await response.json();
        // console.log(data.data);
        setSearchData(data.data);
        // setSearchParams(
        //   constructQueryParameters(
        //     formattedStartDate,
        //     formattedEndDate,
        //     selectedPayableCity,
        //     selectedPaymentMethod,
        //   ),
        // );
        const queryParams = constructQueryParameters(
          formattedStartDate,
          formattedEndDate,
          selectedPayableCity,
          selectedPaymentMethod,
          selectedSortMethod,
        );
        const { areaId, clusterId, zoneId, regionId, chapterId, districtId, blockId } =
          values;

        const {
          areaName,
          clusterName,
          zoneName,
          regionName,
          chapterName,
          districtName,
          blockName,
        } = orgNames;
        const orgParams = [
          areaId !== null && areaName !== null && areaName !== ""
            ? `areaName=${areaName}`
            : "",
          clusterId !== null && clusterName !== null && clusterName !== ""
            ? `clusterName=${clusterName}`
            : "",
          zoneId !== null && zoneName !== null && zoneName !== ""
            ? `zoneName=${zoneName}`
            : "",
          regionId !== null && regionName !== null && regionName !== ""
            ? `regionName=${regionName}`
            : "",
          chapterId !== null && chapterName !== null && chapterName !== ""
            ? `chapterName=${chapterName}`
            : "",
          districtId !== null && districtName !== null && districtName !== ""
            ? `districtName=${districtName}`
            : "",
          blockId !== null && blockName !== null && blockName !== ""
            ? `blockName=${blockName}`
            : "",
        ]
          .filter(Boolean)
          .join("&");
        setSearchParams(`${queryParams}${orgParams ? `&${orgParams}` : ""}`);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
    // finally{
    //   setIsLoading(false);
    // }

    // Extract form values using formRef
    // const rawFormData = new FormData(formRef.current);
    // const formData = formDataToObject(rawFormData);
    // formData.pageNumber = 0;
    // formData.pageSize = Constants.DEFAULT_PAGE_SIZE;
    // const query = queryString.stringify(formData);

    // Close all popover
    document.dispatchEvent(new Event(EVENT_NAME));
    // updateSearchParam(query); // it will trigger below useEffect
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    const formattedStartDate = moment(
      initialAdvanceFormValue.dateOfBirthFrom,
    ).format("YYYY-MM-DD");
    const formattedEndDate = moment(
      initialAdvanceFormValue.dateOfBirthTo,
    ).format("YYYY-MM-DD");
    const queryParams = constructQueryParameters(
      formattedStartDate,
      formattedEndDate,
      selectedPayableCity,
      selectedPaymentMethod,
      selectedSortMethod,
    );
    const { areaId, clusterId, zoneId, regionId, chapterId, districtId, blockId } = values;

    const {
      areaName,
      clusterName,
      zoneName,
      regionName,
      chapterName,
      districtName,
      blockName,
    } = orgNames;
    const orgParams = [
      areaId !== null && areaName !== null && areaName !== ""
        ? `areaName=${areaName}`
        : "",
      clusterId !== null && clusterName !== null && clusterName !== ""
        ? `clusterName=${clusterName}`
        : "",
      zoneId !== null && zoneName !== null && zoneName !== ""
        ? `zoneName=${zoneName}`
        : "",
      regionId !== null && regionName !== null && regionName !== ""
        ? `regionName=${regionName}`
        : "",
      chapterId !== null && chapterName !== null && chapterName !== ""
        ? `chapterName=${chapterName}`
        : "",
      districtId !== null && districtName !== null && districtName !== ""
        ? `districtName=${districtName}`
        : "",
      blockId !== null && blockName !== null && blockName !== ""
        ? `blockName=${blockName}`
        : "",
    ]
      .filter(Boolean)
      .join("&");
    try {
      // const url = `${
      //   SERVICES.GET_LIST_CHEQUES_DD_REPORTS
      // }?${constructQueryParameters(
      //   formattedStartDate,
      //   formattedEndDate,
      //   selectedPayableCity,
      //   selectedPaymentMethod,
      // )}&pageNumber=${selectedPage}&pageSize=${10}`;
      const url = `${SERVICES.GET_LIST_CHEQUES_DD_REPORTS}?${queryParams}${
        orgParams ? `&${orgParams}` : ""
      }&pageNumber=${selectedPage}&pageSize=${10}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setSearchData(data.data);
        // setSearchParams(
        //   `${constructQueryParameters(
        //     formattedStartDate,
        //     formattedEndDate,
        //     selectedPayableCity,
        //     selectedPaymentMethod,
        //   )}&pageNumber=${selectedPage}&pageSize=${10}`,
        // );
        setSearchParams(
          `${queryParams}${
            orgParams ? `&${orgParams}` : ""
          }&pageNumber=${selectedPage}&pageSize=${10}`,
        );
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (searchData.content) {
      const updatedTableData = searchData.content.map((item, index) => {
        // const serialNumber = currentPage * DEFAULT_PAGE_SIZE + index + 1;
        const serialNumber = currentPage * 10 + index + 1;
        return {
          // id: item.id,
          "S.No.": serialNumber,
          // "Member Id": item?.id,
          "Member Name": item?.fullName,
          Mode:
            item?.paymentTransaction?.paymentMethodType === "CHEQUE"
              ? "Cheque"
              : "Demand Draft",
          "Cheque/DD No": item?.paymentTransaction?.chequeNumber,
          "Cheque Date":
            item?.paymentTransaction?.chequeDate !== null
              ? moment(item?.paymentTransaction?.chequeDate).format(
                  "DD/MM/YYYY",
                )
              : "NA",
          "Bank Name":
            item?.paymentTransaction?.otherBankName ??
            item?.paymentTransaction?.drawnBankName,
          Amount: item?.amount,
          "Payable City": item?.payableCityName,
        };
      });
      // setTableData(updatedTableData);
      setChequeData(updatedTableData);
      // setSearchText("");
    }
  }, [searchData.content]);
  // console.log(chequeData);
  useEffect(() => {
    // const queryObject = getQueryObject();
    // if (!isEmptyObj(queryObject)) {
    //   const [query, params] = getQueryParams(queryObject);
    //   fetchSearchData(query, params.pageNumber, params.pageSize);
    //   initializeFormState(query);
    // } else {
    //   resetFormState();
    // }
    Object.keys(initialFormValue).forEach((key) => {
      setInitialAdvanceFormValue((prev) => ({
        ...prev,
        // [key]: query[key] ?? "",
      }));
    });
  }, [urlSearchParams.toString()]);

  // useEffect(() => {
  //   const queryObject = getQueryObject();
  //   if (!isEmptyObj(queryObject)) {
  //     const query = getQueryParams(queryObject)[0];
  //     setAppliedFilters(getFilters(query, metaData));
  //   }
  // }, [metaData, urlSearchParams.toString()]);

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      // type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.TOTAL_RECEIPT_REPORT.path);
  };

  const onSelectMember = (member) => {
    navigate(`/${ROUTES.TOTAL_RECEIPT_REPORT.path}/${member.memberId}`);
  };

  const onMemberStatusToggle = (member) => {
    setSelectedMember(member);
    onModalToggle();
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };

  // const clearAllFilter = () => {
  //   updateSearchParam();
  // };
  // console.log(searchData);
  const renderAppliedFilter = (paramKey, displayName, value, onRemove) => {
    return (
      queryParams.get(paramKey) && (
        <AppliedFilter
          filter={{
            displayName,
            value,
          }}
          onRemove={onRemove}
        />
      )
    );
  };
  const onRemoveFilter = (filterKey) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    updatedSearchParams.delete(filterKey);
    setSearchParams(updatedSearchParams.toString());
  };
  const onRemoveTwoFilter = (...filterKeys) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    filterKeys.forEach((key) => {
      updatedSearchParams.delete(key);
    });

    setSearchParams(updatedSearchParams.toString());
  };
  const convertTypeFormat = (type) => {
    const formattedType = type
      ?.split("_")
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      )
      ?.join(" ");

    return formattedType;
  };
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const filters = [
    // org values
    renderAppliedFilter("areaId", "Area", searchParams.get("areaName"), () =>
      onRemoveTwoFilter("areaId", "areaName"),
    ),
    renderAppliedFilter("clusterId", "Cluster", searchParams.get("clusterName"), () =>
      onRemoveTwoFilter("clusterId", "clusterName"),
    ),
    renderAppliedFilter("zoneId", "Zone", searchParams.get("zoneName"), () =>
      onRemoveTwoFilter("zoneId", "zoneName"),
    ),
    renderAppliedFilter(
      "regionId",
      "Region",
      searchParams.get("regionName"),
      () => onRemoveTwoFilter("regionId", "regionName"),
    ),
    renderAppliedFilter(
      "chapterId",
      "Chapter",
      searchParams.get("chapterName"),
      () => onRemoveTwoFilter("chapterId", "chapterName"),
    ),
    renderAppliedFilter(
      "districtId",
      "District",
      searchParams.get("districtName"),
      () => onRemoveTwoFilter("districtId", "districtName"),
    ),
    renderAppliedFilter("blockId", "Block", searchParams.get("blockName"), () =>
      onRemoveTwoFilter("blockId", "blockName"),
    ),
    // Advance Search
    renderAppliedFilter(
      "payableCity",
      "Payable City",
      searchParams.get("payableCity"),
      () => onRemoveFilter("payableCity"),
    ),
    renderAppliedFilter(
      "orderPaymentMethod",
      "Payment Method",
      convertTypeFormat(searchParams.get("orderPaymentMethod")),
      () => onRemoveFilter("orderPaymentMethod"),
    ),
    renderAppliedFilter(
      "from",
      "Date Range",
      `${moment(searchParams.get("from")).format("DD-MMM-YYYY")} - ${moment(
        searchParams.get("to"),
      ).format("DD-MMM-YYYY")}`,
      () => onRemoveTwoFilter("from", "to"),
    ),
    renderAppliedFilter("sort", "Sorting", searchParams.get("sort"), () =>
      onRemoveFilter("sort"),
    ),
  ];
  useEffect(() => {
    if (queryParams.get("sort") === null) {
      setSelectedSortMethod("");
    }
  }, [queryParams.get("sort")]);
  useEffect(() => {
    getUserRole();
  }, []);
  useEffect(() => {
    if (profileData?.assignedRoles?.includes("contributionOfflineDataEntry")) {
      setSelectedReportType("Cheque Deposit List");
    }
  }, [profileData]);
  return (
    <div style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Cheques/DD Reports" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <div style={styles.container}>
          <div style={styles.filter}>
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              {/* {SEARCH_FILTERS.map(
                ({ component: Component, popOverprops, key }) => (
                  <Popover key={key} {...popOverprops} >
                    <Component formRef={formRef} />
                  </Popover>
                )
              )} */}
              <DateRangePicker
                label="Date"
                name="date"
                startDateVal={initialAdvanceFormValue.dateOfBirthFrom}
                endDateVal={initialAdvanceFormValue.dateOfBirthTo}
                onChange={(startDate, endDate) => {
                  setInitialAdvanceFormValue({
                    ...initialAdvanceFormValue,
                    dateOfBirthFrom: startDate,
                    dateOfBirthTo: endDate,
                  });
                }}
              />
              {/* <Popover heading="Organization Structure" minWidth={413}>
                <OrganizationStructure
                  clearValues={clearContributions}
                  setNameValues={setOrgNames}
                  onUpdateValues={updateOrganizationStructureValues}
                />
              </Popover> */}
              <Popover heading="Organization Structure" minWidth={413}>
                {profileData?.assignedRoles?.includes(
                  "contributionOfflineDataEntry",
                ) ? (
                  <OrganizationStructureForUser
                    clearValues={clearContributions}
                    setNameValues={setOrgNames}
                    onUpdateValues={updateOrganizationStructureValues}
                    initialAreaId={profileData?.areaId}
                    initialClusterId={profileData?.clusterId}
                    initialZoneId={profileData?.zoneId}
                    initialRegionId={profileData?.regionId}
                    initialChapterId={profileData?.chapterId}
                    disabled
                  />
                ) : (
                  <OrganizationStructure
                    clearValues={clearContributions}
                    setNameValues={setOrgNames}
                    onUpdateValues={updateOrganizationStructureValues}
                  />
                )}
                {/* <OrganizationStructure
                  clearValues={clearContributions}
                  setNameValues={setOrgNames}
                  onUpdateValues={updateOrganizationStructureValues}
                /> */}
              </Popover>
              {/* {(profileData?.assignedRoles?.includes("contributionAdmin") ||
                profileData?.assignedRoles?.includes(
                  "contributionDataEntry",
                )) && (
                <Popover heading="Advance Search" minWidth={413}>
                  <AdvancedSearch
                    updatePayableCity={updatePayableCity}
                    updatePaymentMethod={updatePaymentMethod}
                    updateReportType={updateReportType}
                    updateSortingMethod={updateSortingMethod}
                  />
                </Popover>
              )} */}
              <Popover heading="Advance Search" minWidth={413}>
                <AdvancedSearch
                  updatePayableCity={updatePayableCity}
                  updatePaymentMethod={updatePaymentMethod}
                  updateReportType={updateReportType}
                  updateSortingMethod={updateSortingMethod}
                />
              </Popover>
              <Button type="submit">Search</Button>
            </form>
            <Button cancel onClick={removeFilter}>
              Reset
            </Button>
          </div>
          {searchPerformed && (
            <div style={styles.filterWrapper}>
              <div style={styles.filterContainer}>
                {filters.map((filter, index) => (
                  <>{filter}</>
                ))}
              </div>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <div />
            <div>
              {profileData?.assignedRoles?.includes(
                "contributionOfflineDataEntry",
              ) ? (
                <ExportButtonForChapter
                  data={chequeData}
                  selectedReport={selectedReport}
                />
              ) : (
                <ExportButton
                  data={chequeData}
                  selectedReport={selectedReport}
                />
              )}
            </div>
          </div>
          <div style={styles.main}>
            {/* {chequeData?.length ? (
              <div style={styles.totalElements}>
                Total Members: {searchData.totalElements}
              </div>
            ) : null} */}
            {appliedFilters.length ? (
              <div style={styles.filterWrapper}>
                <div style={styles.filterContainer}>
                  {appliedFilters.map((filter) => (
                    <AppliedFilter
                      key={filter.key}
                      filter={filter}
                      // onRemove={onRemoveFilter}
                    />
                  ))}
                </div>
                {/* <div style={styles.clearAll} onClick={clearAllFilter}>
                  Clear
                </div> */}
              </div>
            ) : null}
            {!searchPerformed ? (
              <div style={styles.initialContent}>
                <SearchIconWithPeople width={100} />
                <span style={styles.text}>Choose your Search Filter</span>
              </div>
            ) : chequeData?.length > 0 ? (
              <div style={{ marginTop: "20px" }}>
                <GenericTable
                  tableData={chequeData}
                  data={searchData}
                  headers={tableHeaders}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : (
              <div style={styles.initialContent}>
                <EmptyFileIcon width={100} />
                <span style={styles.text}>
                  No data found with current Filters
                </span>
              </div>
            )}
          </div>
          {isLoading && <Loader />}
        </div>
      </OuterContainerStyles>
    </div>
  );
}

export default ChequesReportsSearch;
